// extracted by mini-css-extract-plugin
export default {"text":"SignupHelp_text__7UY6k","phone":"SignupHelp_phone__oORTG"};